import JSZip from "jszip";
import { api } from "./api.js";

function parseCSV(text) {
  const rows = [];
  let row = [];
  let field = "";
  let quoted = false;
  for (let index = 0; index < text.length; index += 1) {
    const character = text[index];
    if (character === '"') {
      if (quoted && text[index + 1] === '"') { field += '"'; index += 1; }
      else quoted = !quoted;
    } else if (character === "," && !quoted) {
      row.push(field); field = "";
    } else if ((character === "\n" || character === "\r") && !quoted) {
      if (character === "\r" && text[index + 1] === "\n") index += 1;
      row.push(field); field = "";
      if (row.some((value) => value.trim())) rows.push(row);
      row = [];
    } else field += character;
  }
  row.push(field);
  if (row.some((value) => value.trim())) rows.push(row);
  if (rows.length < 2) return [];
  const headers = rows[0].map((value) => value.trim().toLowerCase());
  return rows.slice(1).map((values) => Object.fromEntries(headers.map((header, index) => [header, (values[index] || "").trim()])));
}

const keyFor = (row) => `${(row.name || row.title || "").trim().toLowerCase()}|${row.year || ""}|${row.date || row.watcheddate || ""}`;
const numberOrNull = (value) => value === "" || value == null ? null : Number(value);

function mergeEntry(map, row, patch) {
  const title = row.name || row.title;
  if (!title) return;
  const key = keyFor(row);
  const current = map.get(key) || { title, year: numberOrNull(row.year), isWatched: false, inWatchlist: false, isRewatch: false, tags: [] };
  map.set(key, { ...current, ...patch, title, year: numberOrNull(row.year) });
}

export async function importLetterboxdZIP(file, onProgress = () => {}) {
  const zip = await JSZip.loadAsync(file);
  const entries = new Map();
  const readRows = async (name) => {
    const found = Object.values(zip.files).find((item) => item.name.toLowerCase() === name.toLowerCase());
    return found ? parseCSV(await found.async("string")) : [];
  };

  (await readRows("watched.csv")).forEach((row) => mergeEntry(entries, row, { isWatched: true }));
  (await readRows("watchlist.csv")).forEach((row) => mergeEntry(entries, row, { inWatchlist: true }));
  (await readRows("ratings.csv")).forEach((row) => mergeEntry(entries, row, { isWatched: true, rating: numberOrNull(row.rating) }));
  (await readRows("reviews.csv")).forEach((row) => mergeEntry(entries, row, {
    isWatched: true,
    rating: numberOrNull(row.rating),
    review: row.review || "",
    activityDate: row.date || null,
    watchedDate: row.watcheddate || row.date || null,
    tags: row.tags ? row.tags.split(",").map((tag) => tag.trim()).filter(Boolean) : []
  }));
  (await readRows("diary.csv")).forEach((row) => mergeEntry(entries, row, {
    isWatched: true,
    watchedDate: row.watcheddate || row.date || null,
    activityDate: row.date || row.watcheddate || null,
    rating: numberOrNull(row.rating),
    isRewatch: /^(yes|true|1)$/i.test(row.rewatch || "")
  }));

  const records = [...entries.values()];
  const unmatched = [];
  let imported = 0;
  for (let index = 0; index < records.length; index += 10) {
    const response = await api("/v1/import/letterboxd", { method: "POST", body: { entries: records.slice(index, index + 10) } });
    imported += response.imported || 0;
    unmatched.push(...(response.unmatched || []));
    onProgress({ current: Math.min(index + 10, records.length), total: records.length, imported });
  }

  const listFiles = Object.values(zip.files).filter((item) => !item.dir && /^lists\/.*\.csv$/i.test(item.name));
  let listsImported = 0;
  for (const listFile of listFiles) {
    const rows = parseCSV(await listFile.async("string"));
    if (!rows.length) continue;
    const name = listFile.name.split("/").pop().replace(/\.csv$/i, "").replace(/-/g, " ");
    const response = await api("/v1/import/letterboxd/list", {
      method: "POST",
      body: { name, isRanked: true, items: rows.map((row) => ({ title: row.name || row.title, year: numberOrNull(row.year), note: row.description || row.notes || "" })) }
    });
    unmatched.push(...(response.unmatched || []));
    listsImported += 1;
  }
  return { imported, total: records.length, listsImported, unmatched: [...new Set(unmatched)] };
}
